import * as fromOperCapasActions from '../../../actions/AdmMapa/Cartografia/CapasOper.actions';

export interface OperCapasState {
    Accion: string;
    IdCarto: string;
}

const initialStateOperC: OperCapasState = {
    Accion: '',
    IdCarto: ''
};

export function operCartoReducer(state = initialStateOperC, action: fromOperCapasActions.OperCartoActions): OperCapasState {
    switch (action.type) {
        case fromOperCapasActions.AGREGAR_CARTO:
            return {
                ...state,
                Accion: 'Agregar',
                IdCarto: action.IdCarto
            };
        case fromOperCapasActions.ELIMNAR_CARTO:
            return {
                ...state,
                Accion: 'Eliminar',
                IdCarto: action.IdCarto
            };
      default: {
        return state;
      }
    }
}
